import { createFileRoute } from '@tanstack/react-router';
import { SOnboarding } from '@/screens/SOnboarding/SOnboarding';

type Step =
  | 'site'
  | 'asset'
  | 'sensor'
  | 'assignment'
  | 'invite'
  | 'done';

export const Route = createFileRoute('/$orgId/onboarding')({
  component: SOnboarding,
  validateSearch: (raw: Record<string, unknown>): { step?: Step } => {
    const allowed: Step[] = ['site', 'asset', 'sensor', 'assignment', 'invite', 'done'];
    const s = typeof raw.step === 'string' ? raw.step : undefined;
    return { step: allowed.includes(s as Step) ? (s as Step) : undefined };
  },
});
